// Dependencies
import styled from 'styled-components';

const alignment = {
  text: (props) => props?.alignment?.text || 'left',
  horizontal: (props) => props?.alignment?.horizontal || 'flex-start',
  vertical: (props) => props?.alignment?.vertical || 'flex-start',
};

const TwoColumnStyles = styled.section`
  .layout-heading {
    text-align: center;
  }

  .column {
    order: 2;
    width: 100%;
    margin: 0 0 1.5rem;
    text-align: ${alignment?.text};

    .heading {
      text-align: ${alignment?.text};
    }

    .img {
      width: 100%;
      margin: 0 0 2rem;
    }

    .icon {
      max-width: 2.5rem;
      max-height: 2.5rem;
      margin: 0 0 0.5rem;
    }

    &.img-only-column {
      margin: 0 0 1.5rem;
      order: 1;

      .img {
        margin: 0;
      }

      &:nth-child(3) {
        order: 3;
      }
    }

    &:nth-child(4) {
      order: 4;
    }

    &:last-child:not(.img-only-column) {
      margin: 0;
    }
  }

  @media (min-width: 768px) {
    .layout-heading {
      padding: 0 0 2rem;
    }

    .column {
      display: flex;
      align-items: ${alignment?.vertical};
      justify-content: ${alignment?.horizontal};
      flex-wrap: wrap;
      flex-direction: row;
      order: unset;
      width: calc(50% - 40px);

      &.img-only-column {
        order: unset;

        .img {
          margin: 0 0 2rem;
        }

        &:nth-child(3) {
          order: unset;
        }
      }

      &:last-child {
        margin: 0;
      }

      &:nth-child(4) {
        order: unset;
      }

      .btn-group {
        justify-content: start;
      }
    }
  }

  @media (min-width: 992px) {
    .column {
      width: calc(50% - 75px);
    }
  }
`;

export default TwoColumnStyles;
